import { render, staticRenderFns } from "./ConsolidationUnionTableMobile.vue?vue&type=template&id=2f781527&scoped=true"
import script from "./ConsolidationUnionTableMobile.vue?vue&type=script&lang=js"
export * from "./ConsolidationUnionTableMobile.vue?vue&type=script&lang=js"
import style0 from "./ConsolidationUnionTableMobile.vue?vue&type=style&index=0&id=2f781527&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f781527",
  null
  
)

export default component.exports